import { useEffectOnce } from 'react-use'
import { useCreateOrganizationOnboarding } from 'api/endpoints/organizations'
import { OrganizationType } from 'lib/generated/api'
import { useHistory, useParams, useLocation } from 'lib/router'
import { useState } from 'react'
import Welcome from 'views/Onboarding/Welcome'
import { GlobalShell } from 'components/GlobalShell'

export const OnboardingWelcomeContainer = () => {
  let [recordId, setRecordId] = useState('')
  let [navigateToNext, setNavigateToNext] = useState(false)

  const history = useHistory()
  const { onboardingRecordId } = useParams<{
    onboardingRecordId?: string
  }>()

  const { search } = useLocation()
  const brokenSearch = new URLSearchParams(search)
  const organizationType = brokenSearch.get('orgType') as OrganizationType
  const connectionId = brokenSearch.get('connectionId')

  const create = useCreateOrganizationOnboarding()

  useEffectOnce(() => {
    if (onboardingRecordId) {
      setRecordId(onboardingRecordId)
    } else {
      create.mutate(
        {
          organizationOnboarding: {
            organizationLocale: 'en-US',
            connectionId: connectionId || undefined,
            organizationType:
              organizationType && organizationType in OrganizationType
                ? organizationType
                : OrganizationType.Company,
          },
        },
        {
          onSuccess: data => {
            setRecordId(data.onboardingRecordId)
            if (navigateToNext)
              history.push(`/welcome/${data.onboardingRecordId}/form`)
          },
        }
      )
    }
  })

  return (
    <GlobalShell>
      <Welcome
        onNext={() => {
          if (recordId) {
            history.push(`/welcome/${recordId}/form`)
          } else {
            setNavigateToNext(true)
          }
        }}
      />
    </GlobalShell>
  )
}
